import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
} from 'react-bootstrap';

import {
  tokenWithdrawBalance,
} from '../util/thunks';

class WithdrawForm extends React.Component {

  render() {
    return (
      <form onSubmit={this._handleSubmit}>
        <Button type="submit">Withdraw Balance</Button>
      </form>
    );
  }

  _handleSubmit = (e) => {
    e.preventDefault();
    this.props.tokenWithdrawBalance();
  }

}

const mapDispatchToProps = (dispatch) => ({

  tokenWithdrawBalance: () => {
    return dispatch(tokenWithdrawBalance());
  },

});

export default connect(null, mapDispatchToProps)(WithdrawForm);



// WEBPACK FOOTER //
// ./src/components/WithdrawForm.js